import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/commitment/bjCommitment/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/bjCommitment'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/commitment/panJinCommitment/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/panJinCommitment'
  }
]
